import styled from 'styled-components'
import { Icon } from 'semantic-ui-react'

export const ThemedIcon = styled(Icon)`
  color: ${props =>
    props.color ? props.color : props.theme.colors.turquoiseGreen};
`
